export default __webpack_public_path__ + "static/media/catalog_point_img03.2b5462d8.svg";